import { FaBrain, FaUsers, FaClipboardCheck, FaGlobe } from 'react-icons/fa6';

const counter = [
  {
    id: 1,
    icon: <FaBrain />, // AI icon
    title: 'AI Solutions',
    count: '500',
  },
  {
    id: 2,
    icon: <FaUsers />, // Users icon
    title: 'Customers Served',
    count: '1500',
  },
  {
    id: 3,
    icon: <FaClipboardCheck />, // Projects icon
    title: 'Projects Done',
    count: '120',
  },
  {
    id: 4,
    icon: <FaGlobe />, // Globe icon
    title: 'Global Reach',
    count: '30',
  },
];

export default counter;